import { DatastoreProvider, InstanceDashboard } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { rankingEvalModuleQuery } from 'system/structure-modules';

export default function RankingEvalDashboardLayout() {
    const { siloKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/ranking-eval/one`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'ranking-eval',
        instanceKey: 'one',
        moduleQuery: rankingEvalModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceDashboard />
        </DatastoreProvider>
    );
}
